/// <reference types="vite/client" />

export const CENTRALISED_BILLING_API = import.meta.env
  .VITE_CENTRALISED_BILLING_API;

export const CENTRAL_DASHBOARD_BACKEND_API = import.meta.env
  .VITE_CENTRAL_DASHBOARD_BACKEND_API;

export const BILLING_DETAILS_UPDATE_API = import.meta.env
  .VITE_BILLING_DETAILS_UPDATE_API;

export const UNIFIED_DASHBOARD_URL = import.meta.env.VITE_UNIFIED_DASHBOARD_URL;

// R2 bucket whose per-workspace cost the Track Usage page shows.
export const R2_COST_BUCKET = import.meta.env.VITE_R2_COST_BUCKET;

export const PHOTOGENIX_API = import.meta.env.VITE_PHOTOGENIX_API;

export const PHOTOGENIX_API_ADMIN_TOKEN = import.meta.env.VITE_ADMIN_TOKEN;

export const IMAGE_UPLOAD_API = import.meta.env.VITE_IMAGE_UPLOAD_API;

export const STRIPE_PUBLISHABLE_KEY = import.meta.env
  .VITE_STRIPE_PUBLISHABLE_KEY;

export const STRIPE_SUBSCRIPTION_PAGE_URL = import.meta.env
  .VITE_STRIPE_SUBSCRIPTION_PAGE_URL;
